import { render, staticRenderFns } from "./KategoriBerita.vue?vue&type=template&id=2f1780de&scoped=true"
import script from "./KategoriBerita.vue?vue&type=script&lang=js"
export * from "./KategoriBerita.vue?vue&type=script&lang=js"
import style0 from "./KategoriBerita.vue?vue&type=style&index=0&id=2f1780de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1780de",
  null
  
)

export default component.exports